export const API_URL = process.env.REACT_APP_API_URL;
export const EXACT_ONLINE_AUTH_URL =
  process.env.REACT_APP_EXACT_ONLINE_AUTH_URL;
export const CHAT_API_URL = process.env.REACT_APP_API_URL;
export const USER_SIGNUP = "USER_SIGNUP";
export const USER_LOGIN = "USER_LOGIN";
export const USER_LOGOUT = "USER_LOGOUT";
export const FETCH_MYFACEBOOK = "FETCH_MYFACEBOOK";
export const SEND_EMAIL = "SEND_EMAIL";
export const EMAIL_EXIST_OR_NOT = "EMAIL_EXIST_OR_NOT";

export const FORGOT_PASS = "FORGOT_PASS";
export const FETCH_USER_BY_ID = "FETCH_USER_BY_ID";
export const USER_CREATE = "USER_CREATE";
export const USER_UPDATE = "USER_UPDATE";
export const CLEAR_USER_UPDATE = "CLEAR_USER_UPDATE";
export const FETCH_DOCUMENT_BY_ID = "FETCH_DOCUMENT_BY_ID";
export const ADD_DOC_TO_USER = "ADD_DOC_TO_USER";
export const ADD_DOC_TO_CONTACT = "ADD_DOC_TO_CONTACT";
export const ADD_DOC_TO_SUPPLIER = "ADD_DOC_TO_SUPPLIER";

export const ADD_DOC_TO_CLIENT = " ADD_DOC_TO_CLIENT";
export const UPLOAD_TO = "UPLOAD_TO";
export const DELETE_DOCUMENET = "DELETE_DOCUMENET";
export const FETCH_JOB_TYPES = "FETCH_JOB_TYPES";
export const DELETE_JOB_TYPES = " DELETE_JOB_TYPES";
export const DELETE_Contacts = " DELETE_Contacts";
export const CREATE_UNLINK = "CREATE_UNLINK";
export const ADD_JOB_TPYE = "ADD_JOB_TPYE";
export const UPDATE_JOB_TPYE = "UPDATE_JOB_TPYE";
export const FETCH_TASK_BY_CONTACT_ID = "FETCH_TASK_BY_CONTACT_ID";
export const DELETE_TASK = "DELETE_TASK";
export const UPDATE_TASK_STATUS = "UPDATE_TASK_STATUS";
// export const UPDATE_TASK = "UPDATE_TASK";
// export const DELETE_CHECKLIST = "DELETE_CHECKLIST";
// export const ADD_COMM = "ADD_COMM";
// export const ADD_TASK = "ADD_TASK";
// export const FETCH_TASK_BY_ID = "FETCH_TASK_BY_ID";
// export const ADD_CHECKLIST = "ADD_CHECKLIST";
// export const FETCH_PROJECT_BY_COMPANY = "FETCH_PROJECT_BY_COMPANY";
// export const FETCH_TASKS_BY_COMPANY_ID = "FETCH_TASKS_BY_COMPANY_ID";
// export const FETCH_USER_BY_COMPANY = "FETCH_USER_BY_COMPANY";
export const FETCH_LINK = "FETCH_LINK";
////////////CHAT////////////////////////////////
export const CHAT_ROOMS_GET = "CHAT_ROOMS_GET";
export const CHAT_ROOMS_SUCCESS = "CHAT_ROOMS_SUCCESS";
export const CHAT_ROOMS_FAILED = "CHAT_ROOMS_FAILED";
export const CHAT_CONVERSATION_GET = "CHAT_CONVERSATION_GET";
export const CHAT_CONVERSATION_SUCCESS = "CHAT_CONVERSATION_SUCCESS";
export const CHAT_CONVERSATION_FAILED = "CHAT_CONVERSATION_FAILED";
export const CHAT_CONVERSATION_PUSH_MESSAGE = "CHAT_CONVERSATION_PUSH_MESSAGE";
export const CHAT_CONVERSATION_LOAD_MORE = "CHAT_CONVERSATION_LOAD_MORE";
export const SEARCH_CONVERSATIONS = "SEARCH_CONVERSATIONS";
export const ADD_INDIVIDUAL_GROUPS = "ADD_INDIVIDUAL_GROUPS";
export const CHAT_NEW_ROOM = "CHAT_NEW_ROOM";
export const UPDATE_MESSAGE = "UPDATE_MESSAGE";
export const GLOBAL_CHAT = "GLOBAL_CHAT";
export const DELETE_MESSAGE = "DELETE_MESSAGE";
export const FETCH_ROLE_MODULE = "FETCH_ROLE_MODULE";
export const FATCH_USER_BY_COMPANY_ID = "FATCH_USER_BY_COMPANY_ID";
export const FATCH_USERS_TO_GROUP = "FATCH_USERS_TO_GROUP";
export const ADD_GROUP = "ADD_GROUP";
export const GROUP_INFO = "GROUP_INFO";
export const SEARCH_CONVERSATION_GROUP = "SEARCH_CONVERSATION_GROUP";
export const ADDUSER_TO_GROUP = "ADDUSER_TO_GROUP";
export const USER_LEAVE_GROUP = "USER_LEAVE_GROUP";
export const ADMIN_ACCESS = "ADMIN_ACCESS";
export const REMOVE_GROUP_ADMIN = "REMOVE_GROUP_ADMIN";
export const UPDATE_GROUP_INFO = "UPDATE_GROUP_INFO";
export const DELETE_CONVERSATION = "DELETE_CONVERSATION";
export const CHAT_DELETE_MESSAGE = "CHAT_DELETE_MESSAGE";

export const FATCH_CONTACT_ID = "FATCH_CONTACT_ID";
export const ADD_TAGS_CONTACT = "ADD_TAGS_CONTACT";
export const FETCH_TAGS_CONTACT = "FETCH_TAGS_CONTACT";
export const FETCH_COMPANY = "FETCH_COMPANY";
export const FETCH_LANGUAGES = "FETCH_LANGUAGES";
export const FETCH_TRANSLATION = "FETCH_TRANSLATION";
export const FETCH_CREATETRANSLATION = "FETCH_CREATETRANSLATION";
export const UPDATE_TRANSLATION_DATA = "UPDATE_TRANSLATION_DATA";
export const FETCH_SCREEN = "FETCH_SCREEN";
export const FETCH_MANAGERS_LIST = "FETCH_MANAGERS_LIST";
export const FETCH_CONTACT_BYID = "FETCH_CONTACT_BYID";
export const FETCH_SUPPLIER_BYID = "FETCH_SUPPLIER_BYID";

export const FETCH_SEARCH_CLIENTS = "FETCH_SEARCH_CLIENTS";
export const FETCH_SEARCH_SUPPLIER = "FETCH_SEARCH_SUPPLIER";

export const FETCH_DOCSCONTACT_BYID = "FETCH_DOCSCONTACT_BYID";
export const FETCH_DOCSCLIENT_BYID = "FETCH_DOCSCLIENT_BYID";
export const REMOVE_DOCSCLIENT_BYID = "REMOVE_DOCSCLIENT_BYID";
export const FETCH_LINKCLIENT_BYID = "FETCH_LINKCLIENT_BYID";
export const FETCH_CONTACTSCLIENT_BYID = "FETCH_CONTACTSCLIENT_BYID";
export const DELETE_TAGS = " DELETE_TAGS";
export const DELETE_DOCS = "DELETE_DOCS";
export const ADD_CONTACTS = "ADD_CONTACTS";
export const ADD_COMPANY = "ADD_COMPANY";
export const UPDATE_COMPANY = "UPDATE_COMPANY";
export const UPDATE_CONTACTS = "UPDATE_CONTACTS";
export const ACTIVE_STATUS = "ACTIVE_STATUS";
// export const FETCH_USER_BY_ID  = "FETCH_USER_BY_ID";
////////DOMAINNAME//////////////////////////////////
export const SUB_DOMAIN_NAME = "SUB_DOMAIN_NAME";
export const USER_VERIFY = "USER_VERIFY";

export const FETCH_USER_NOTIFICATION = "FETCH_USER_NOTIFICATION";

export const FETCH_TASKS_BY_COMPANY_ID = "FETCH_TASKS_BY_COMPANY_ID";
export const FETCH_TASK_BY_ID = "FETCH_TASK_BY_ID";
export const UPDATE_TASK = "UPDATE_TASK";
export const ADD_COMM = "ADD_COMM";
export const IS_CURRENTCOMPANY = "IS_CURRENTCOMPANY";
export const FETCH_USER_BY_COMPANY = "FETCH_USER_BY_COMPANY";
export const FETCH_PROJECT_BY_COMPANY = "FETCH_PROJECT_BY_COMPANY";
export const DELETE_CHECKLIST = "DELETE_CHECKLIST";
export const ADD_CHECKLIST = "ADD_CHECKLIST";
export const ADD_TASK = "ADD_TASK";

export const TASK_FOR_A_WEEK = "TASK_FOR_A_WEEK";
export const UPDATE_CALENDAR_DATA = "UPDATE_CALENDAR_DATA";
export const TASK_GROUPING = "TASK_GROUPING";
export const FETCH_WEEKLY = "FETCH_WEEKLY";
///////ROLEMODULE ACCESS////////////////
export const FATCH_ROLEMODULE_ACCESS = "FATCH_ROLEMODULE_ACCESS";
export const FETCH_PROJECT = "FETCH_PROJECT";
export const FETCH_PROJECT_BB = "FETCH_PROJECT_BB";
export const FETCH_TASK_BY_PROJECT = "FETCH_TASK_BY_PROJECT";
export const CREATE_PROJECT = "CREATE_PROJECT";
export const FETCH_CLIENT = "FETCH_CLIENT";
export const FETCH_ACTIVE_USER = "FETCH_ACTIVE_USER";
export const FETCH_PROJECT_BY_ID = "FETCH_PROJECT_BY_ID";
export const UPDATE_PROJECT_BY_ID = "UPDATE_PROJECT_BY_ID";
export const ADD_DOCUMENT_PROJECT = "ADD_DOCUMENT_PROJECT";
export const FETCH_DOCUMENT_PROJECT = "FETCH_DOCUMENT_PROJECT";
export const TASK_TODAY = "TASK_TODAY";
export const CHANGE_STATUS = "CHANGE_STATUS";
export const FETCH_SUPPLIERS = "FETCH_SUPPLIERS";
export const FETCH_PROJECTS = "FETCH_PROJECTS";
export const FETCH_PRODUCT_BY_SUPPLIER_ID = "FETCH_PRODUCT_BY_SUPPLIER_ID";
export const ADD_PURCHASING_ORDER = "ADD_PURCHASING_ORDER";
export const SEND_EMAIL_FOR_PURCHASING_ORDER =
  "SEND_EMAIL_FOR_PURCHASING_ORDER";
export const FETCH_PO_ORDER_CODE = "FETCH_PO_ORDER_CODE";
export const FETCH_WAREHOUSE_PURCHASING_ORDER =
  "FETCH_WAREHOUSE_PURCHASING_ORDER";
export const FETCH_PURCHASING_ORDER = "FETCH_PURCHASING_ORDER";

// *************CURRENT CHANGE*********************
export const ADD_SUPPLIER = "ADD_SUPPLIER";
export const UPDATE_SUPPLIER = "UPDATE_SUPPLIER";
export const FETCH_DOCSUPPLIER_BYID = "FETCH_DOCSUPPLIER_BYID";
export const FETCH_SUPPLIERS_LIST = "FETCH_SUPPLIERS_LIST";

export const ADD_TO_WAREHOUSE = "ADD_TO_WAREHOUSE";
export const UPDATE_ORDER_PRODUCT_QTY = "UPDATE_ORDER_PRODUCT_QTY";
export const ADD_ITEM_IN_EXISTING_ORDER = "ADD_ITEM_IN_EXISTING_ORDER";

export const FETCH_PRODUCT = "FETCH_PRODUCT";
export const DELETE_PRODUCT = "DELETE_PRODUCT";
export const FETCH_SUPPLIERS_PRODUCT = "FETCH_SUPPLIERS_PRODUCT";
export const ADD_PRODUCT_PART = "ADD_PRODUCT_PART";
export const FETCH_PRODUCT_PART = "FETCH_PRODUCT_PART";
export const EMPTY_PRODUCT_PART = "EMPTY_PRODUCT_PART";
export const PRODUCT_PART_CODE_EMAIL_EXIST_OR_NOT =
  "PRODUCT_PART_CODE_EMAIL_EXIST_OR_NOT";
export const ADD_COLOR_CODE = "ADD_COLOR_CODE";
export const DELETE_COLOR = "DELETE_COLOR";
export const ADD_STOCK_COLOR_CODE = "ADD_STOCK_COLOR_CODE";
export const DELETE_STOCK_COLOR = "DELETE_STOCK_COLOR";
export const UPDATE_PRODUCT_PART = "UPDATE_PRODUCT_PART";
export const TOTAL_STOCK_AVAILABLE = "TOTAL_STOCK_AVAILABLE";
export const ADVICED_ITEM_PURCHASE = "ADVICED_ITEM_PURCHASE";
export const JIT_ADVICED_ITEM_PURCHASE = "JIT_ADVICED_ITEM_PURCHASE";
export const ADVICED_PURCHASE_ORDER_LIST = "ADVICED_PURCHASE_ORDER_LIST";
export const JIT_PURCHASE_ORDER_LIST = "JIT_PURCHASE_ORDER_LIST";
export const FETCH_PURCHASING_ORDER_AWAITING =
  "FETCH_PURCHASING_ORDER_AWAITING";
export const FETCH_PAYROLLHISTORY = "FETCH_PAYROLLHISTORY";
export const FETCH_NOT_ENROLLED_PAYROLL = "FETCH_NOT_ENROLLED_PAYROLL";
export const FETCH_DOCUMENT_BY_PRODUCT_PART_ID =
  "FETCH_DOCUMENT_BY_PRODUCT_PART_ID";
export const FETCH_DOCUMENT_BY_ASSETS_ID = "FETCH_DOCUMENT_BY_ASSETS_ID";
export const DELETE_PRODUCT_DOCUMENT = "DELETE_PRODUCT_DOCUMENT";
export const DELETE_ASSETS_DOCUMENT = "DELETE_ASSETS_DOCUMENT";

export const FETCH_PROJECTS_DROPDOWN = "FETCH_PROJECTS_DROPDOWN";
export const FETCH_PROJECT_CLIENT = "FETCH_PROJECT_CLIENT";
export const FETCH_PRODUCT_DROPDOWN = "FETCH_PRODUCT_DROPDOWN";
export const UPDATE_PRODUCT_DROPDOWN = "UPDATE_PRODUCT_DROPDOWN";
export const CREATE_ORDER_PICKING = "CREATE_ORDER_PICKING";
export const UPDATE_PRODUCT_PART_STOCK = "UPDATE_PRODUCT_PART_STOCK";
export const DELETE_PRODUCT_PART_STOCK = "DELETE_PRODUCT_PART_STOCK";
export const ADD_COMPANY_DETAILS = "ADD_COMPANY_DETAILS";
export const GET_USER_TIME_SESSION = "GET_USER_TIME_SESSION";
export const FETCH_PO_BY_PROJECT = "FETCH_PO_BY_PROJECT";
export const FETCH_QUOTES = "FETCH_QUOTES";
export const FETCH_INVOICES = "FETCH_INVOICES";
export const ADD_INVOICES = "ADD_INVOICES";
export const FETCH_LAST_QUOTE_CODE = "FETCH_LAST_QUOTE_CODE";
export const CREATE_DUPLICATE_QUOTES = "CREATE_DUPLICATE_QUOTES";
export const DEACTIVATED_QUOTE = "DEACTIVATED_QUOTE";
export const BOOKKEEPING_PROPS = "BOOKKEEPING_PROPS";

export const CHECK_IF_TIME_SESSION = "CHECK_IF_TIME_SESSION";
export const CREATE_NEW_TIME_SESSION = "CREATE_NEW_TIME_SESSION";
export const GET_TIME_SESSION = "GET_TIME_SESSION";
export const UPDATE_TIME_SESSION = "UPDATE_TIME_SESSION";
export const FETCH_ADD_PROJECT_ID = "FETCH_ADD_PROJECT_ID";
export const GET_ACTIVE_TIME_SESSION = "GET_ACTIVE_TIME_SESSION";
export const STOP_TIMER_FROM_HEADER = "STOP_TIMER_FROM_HEADER";
export const OPEN_TIMER_FROM_HEADER = "OPEN_TIMER_FROM_HEADER";
export const CHANGE_PROJECT_TAB = "CHANGE_PROJECT_TAB";
export const SET_STATUS_TO_FALSE = "SET_STATUS_TO_FALSE";
export const FETCH_INVOICE_BY_ID = "FETCH_INVOICE_BY_ID";
export const UPDATE_INVOICE = "UPDATE_INVOICE";
export const ADD_CREDIT_NOTE = "ADD_CREDIT_NOTE";
export const SET_INVOICE_STATUS_TO_FALSE = "SET_INVOICE_STATUS_TO_FALSE";
export const ADD_UPDATE_FINANCIAL_BY_PROJECT =
  "ADD_UPDATE_FINANCIAL_BY_PROJECT";
export const FETCH_FINANCIAL_BY_PROJECT = "FETCH_FINANCIAL_BY_PROJECT";
export const DELETE_TASK_ID_FROM_TIMER = "DELETE_TASK_ID_FROM_TIMER";
export const UPDATE_PROJECT_COVER = "UPDATE_PROJECT_COVER";
export const FETCH_PROJECT_KAN_BAN = "FETCH_PROJECT_KAN_BAN";
export const PROJECT_GROUPING = "PROJECT_GROUPING";
export const FETCH_PROJECT_WEEKLY = "FETCH_PROJECT_WEEKLY";
export const FETCH_QUOTES_BY_COMPANY_ID = "FETCH_QUOTES_BY_COMPANY_ID";
export const ADD_QUOTES = "ADD_QUOTES";
export const APPROVE_QUOTES = "APPROVE_QUOTES";
export const ADD_SECTION = "ADD_SECTION";
export const GET_QUOTE_SECTIONS = "GET_QUOTE_SECTIONS";
export const DUPLICATE_SECTION = "DUPLICATE_SECTION";
export const DELETE_SECTION = "DELETE_SECTION";
export const UPDATE_QUOTE_SECTIONS = "UDPATE_QUOTE_SECTIONS";
export const DELETE_UPDATE_QUOTE_STATE = "DELETE_UPDATE_QUOTE_STATE";
export const ADD_SUBSECTION = "ADD_SUBSECTION";
export const DELETE_SUBSECTION = "DELETE_SUBSECTION";
export const SET_TIME_SESSION_TO_FALSE = "SET_TIME_SESSION_TO_FALSE";
export const ACTIVATE_QUOTE = "ACTIVATE_QUOTE";
export const FETCH_TEAM_PROJECTWISE = "FETCH_TEAM_PROJECTWISE";
export const FETCH_TEAMS = "FETCH_TEAMS";
export const SET_EQUIPMENTS_DETAIL = "SET_EQUIPMENTS_DETAIL";
export const UPDATE_PO_TASK_STATUS = "UPDATE_PO_TASK_STATUS";
export const ADD_TASK_TO_TEAM = "ADD_TASK_TO_TEAM";
export const GET_PO_LIST = "GET_PO_LIST";
export const APPROVE_PO = "APPROVE_PO";
export const FETCH_INVOICE_ALL_LIST = "FETCH_INVOICE_ALL_LIST";
export const FETCH_PRODUCT_PART_LIST = "FETCH_PRODUCT_PART_LIST";
export const ADD_INVOICE_PROJECT = "ADD_INVOICE_PROJECT";
export const UPDATE_INVOICE_PROJECT = "UPDATE_INVOICE_PROJECT";
export const FETCH_PAYMENT_DEADLINE = "FETCH_PAYMENT_DEADLINE";
export const FETCH_INVOICE_BY_INVOICE_ID = "FETCH_INVOICE_BY_INVOICE_ID";
export const FETCH_PROJECT_BY_CLIENT = "FETCH_PROJECT_BY_CLIENT";
export const FETCH_PRODUCTS_BY_QUOTES = "FETCH_PRODUCTS_BY_QUOTES";
export const INVOICE_DELETE = "INVOICE_DELETE";
export const FETCH_LAST_INVOICE_CODE = "FETCH_LAST_INVOICE_CODE";
export const FETCH_INVOICE_SETTING_LIST = "FETCH_INVOICE_SETTING_LIST";
export const FETCH_MEMBERS = "FETCH_MEMBERS";
export const ADD_TEAM = "ADD_TEAM";
export const FETCH_PRODUCTION_HISTORY = "FETCH_PRODUCTION_HISTORY";
export const FETCH_TEAM_MEMBERS = "FETCH_TEAM_MEMBERS";
export const DELETE_TEAM = "DELETE_TEAM";
export const FETCH_PARTS_LIST = "FETCH_PARTS_LIST";
export const FETCH_TEAM = "FETCH_TEAM";
export const UPDATE_TEAM = "UPDATE_TEAM";
export const DELETE_TEAM_MEMBER = "DELETE_TEAM_MEMBER";
export const ADD_INVOICE_SETTING = "ADD_INVOICE_SETTING";
export const FETCH_INVOICE_SETTING_BY_ID = "FETCH_INVOICE_SETTING_BY_ID";
export const FETCH_ORDER_PICKING_LIST = "FETCH_ORDER_PICKING_LIST";
export const ADD_ORDER_PICKING = "ADD_ORDER_PICKING";
export const FETCH_STOCK_ITEM_LIST = "FETCH_STOCK_ITEM_LIST";
export const ADD_TO_COUNT_STOCK = "ADD_TO_COUNT_STOCK";
export const FETCH_COUNT_STOCK_REPORT = "FETCH_COUNT_STOCK_REPORT";
export const DELETE_COUNT_STOCK = "DELETE_COUNT_STOCK";
export const UPDATE_COUNT_STOCK = "UPDATE_COUNT_STOCK";
export const UPDATE_CHECK_COUNT_STOCK = "UPDATE_CHECK_COUNT_STOCK";
export const QUOTE_EXTRAWORK_VALIDATION = "QUOTE_EXTRAWORK_VALIDATION";
export const FETCH_EQUIPMENT_BY_WEEK = "FETCH_EQUIPMENT_BY_WEEK";
export const ADD_EQUIPMENT_TO_TASK = "ADD_EQUIPMENT_TO_TASK";
export const FETCH_PROVISIONAL = "FETCH_PROVISIONAL";
export const UPDATE_SUPPLIER_CONTACT_POSITION =
  "UPDATE_SUPPLIER_CONTACT_POSITION";
export const FETCH_ASSET_LIST = "FETCH_ASSET_LIST";
export const ADD_ASSETS = "ADD_ASSETS";
export const ASSET_TYPES = "ASSET_TYPES";
export const DELETE_ASSET = "DELETE_ASSET";
export const UPDATE_ASSETS = "UPDATE_ASSETS";
export const FETCH_PARTICULAR_ASSET = "FETCH_PARTICULAR_ASSET";
export const FETCH_GROUP_LIST = "FETCH_GROUP_LIST";
export const ADD_SELECTED_PART = "ADD_SELECTED_PART";
export const REMOVE_SELECTED_PART = "REMOVE_SELECTED_PART";
export const DELETE_GROUP = "DELETE_GROUP";
export const ADD_GROUP_SUCCESS = "ADD_GROUP_SUCCESS";
export const ADD_GROUP_FAILURE = "ADD_GROUP_FAILURE";
export const UPDATE_GROUP = "UPDATE_GROUP";
export const UPDATE_GROUP_SUCCESS = "UPDATE_GROUP_SUCCESS";
export const UPDATE_GROUP_FAILURE = "UPDATE_GROUP_FAILURE";
export const FETCH_EQUIPMENTPARTLIST = "FETCH_EQUIPMENTPARTLIST";
export const FETCH_CLIENT_LIST = "FETCH_CLIENT_LIST";
export const FETCH_EQUIPMENT_LIST = "FETCH_EQUIPMENT_LIST";
export const FETCH_CATEGORY_LIST = "FETCH_CATEGORY_LIST";
export const FETCH_FACILITY_LIST = "FETCH_FACILITY_LIST";
export const ADD_ASSETS_EQUIPMENT = "ADD_ASSETS_EQUIPMENT";
export const FETCH_ASSETS_TYPE_LIST = "FETCH_ASSETS_TYPE_LIST";
export const TEMPLATE_TYPES = "TEMPLATE_TYPES";
export const TEMPLATE_BUILDER_AVAILABLE_FIELDS =
  "TEMPLATE_BUILDER_AVAILABLE_FIELDS";
export const AVAILABLE_TEMPLATES = "AVAILABLE_TEMPLATES";

// Maintenance

export const FETCH_MAINTENANCE_LIST = "FETCH_MAINTENANCE_LIST";
export const ADD_MAINTENANCE = "ADD_MAINTENANCE";
export const FETCH_MAINTENANCE_STATUS_LIST = "FETCH_MAINTENANCE_STATUS_LIST";
export const FETCH_MAINTENANCE_TYPE = "FETCH_MAINTENANCE_TYPE";
export const DELETE_MAINTENANCE = "DELETE_MAINTENANCE";
export const ASSIGN_MANINTENANCE = "ASSIGN_MANINTENANCE";
export const CHANGE_MAINTENANCE_STATUS = "CHANGE_MAINTENANCE_STATUS";
export const FETCH_MAINTENANCE = "FETCH_MAINTENANCE";
export const ADD_COMMENT = "ADD_COMMENT";
export const ADD_ASSET_CHECKLIST = "ADD_CHECKLIST";
export const MARK_CHECKLIST_COMPLETE = "MARK_CHECKLIST_COMPLETE";
export const DELETE_ASSET_CHECKLIST = "DELETE_ASSET_CHECKLIST";
export const DELETE_PO = "DELETE_PO";
export const UPDATE_MAINTENANCE = "UPDATE_MAINTENANCE";
export const FETCH_MAINTENANCE_BY_ID = "FETCH_MAINTENANCE_BY_ID";
export const IS_ACTIVE_WIDGET = "IS_ACTIVE_WIDGET";
export const ACTIVE_WORKER = "ACTIVE_WORKER";
export const FETCH_PURCHASING_ASSET_LIST = "FETCH_PURCHASING_ASSET_LIST";
export const FETCH_LAST_PURCHASING_ORDER_CODE_ASSET_LIST =
  "FETCH_LAST_PURCHASING_ORDER_CODE_ASSET_LIST";
export const ADD_ASSET_PURCHASING_ORDER = "ADD_ASSET_PURCHASING_ORDER";
export const DELETE_PO_ASSET = "DELETE_PO_ASSET";
export const CHANGE_PO_STATUS = "CHANGE_PO_STATUS";
export const FETCH_ASSET_EQUIPMENT_LIST = "FETCH_ASSET_EQUIPMENT_LIST";
export const FETCH_ASSET_TREE_LIST = "FETCH_ASSET_TREE_LIST";
export const TOP_PROJECT = "TOP_PROJECT";
export const FETCH_TODAYONBOARDDETAILS = "FETCH_TODAYONBOARDDETAILS";
export const FETCH_INVENTORY = "FETCH_INVENTORY";
export const WEEK_PROJECTS = "WEEK_PROJECTS";
export const PROJECT_COUNT = "PROJECT_COUNT";
export const FETCH_ASSET_CLIENT_LIST = "FETCH_ASSET_CLIENT_LIST";
export const FETCH_WORK_ORDERS = "FETCH_WORK_ORDERS";
export const ADD_WORK_ORDERS = "ADD_WORK_ORDERS";
export const UPDATE_WORK_ORDER = "UPDATE_WORK_ORDER";
export const FETCH_INSTRUCTIONS_LIST = "FETCH_INSTRUCTIONS_LIST";
export const TURN_UNAVAILABLE = "TURN_UNAVAILABLE";
export const LAST_365_INVOICE_INSIGHTS = "LAST_365_INVOICE_INSIGHTS";
export const MODAL_LIST = "MODAL_LIST";
export const FETCH_ACTIVE_USER_LIST = "FETCH_ACTIVE_USER_LIST";
export const FETCH_EQUIPMENT_TASK_LIST = "FETCH_EQUIPMENT_TASK_LIST";
export const PRODUCT_AND_PART_VALIDATION = "PRODUCT_AND_PART_VALIDATION";
export const FETCH_TEAMS_LIST = "FETCH_TEAMS_LIST";

export const GLOBAL_REQUEST = "GLOBAL_REQUEST";
export const INVOICE_SEND_EMAIL = "INVOICE_SEND_EMAIL";
export const INVOICE_SEND_EMAIL_COUNT = "INVOICE_SEND_EMAIL_COUNT";
export const FETCH_LAST_CREDIT_INVOICE_CODE = "FETCH_LAST_CREDIT_INVOICE_CODE";
export const INVOICE_GENRATE_PDF = "INVOICE_GENRATE_PDF";
export const FETCH_TASK_WITHOUT_PROJECT = "FETCH_TASK_WITHOUT_PROJECT";
export const UPDATE_WAREHOUSE_ORDER_PROJECT = "UPDATE_WAREHOUSE_ORDER_PROJECT";
export const FETCH_PRODUCT_PART_CATEGORIES = "FETCH_PRODUCT_PART_CATEGORIES";
export const FETCH_ASSET_PURCHASING_ORDER_BY_ID =
  "FETCH_ASSET_PURCHASING_ORDER_BY_ID";
export const FETCH_PRODUCT_STOCK_FILTER_LIST =
  "FETCH_PRODUCT_STOCK_FILTER_LIST";
export const SEND_INVOICE_EMAIL = "SEND_INVOICE_EMAIL";
export const SEND_INVOICE_EMAIL_COUNT = "SEND_INVOICE_EMAIL_COUNT";
export const USER_VERIFICATION = "USER_VERIFICATION";
export const UPDATE_SYNC_QB_STATUS = "UPDATE_SYNC_QB_STATUS";
export const PROJECT_COST_DETAILS = "PROJECT_COST_DETAILS";
export const TASK_MODAL_COMMENT_DELETE = "TASK_MODAL_COMMENT_DELETE";
export const ADD_BILLING_INFORMATION = "ADD_BILLING_INFORMATION";
export const UPDATE_BILLING_INFORMATION = "UPDATE_BILLING_INFORMATION";
export const FETCH_BILLING_INFORMATION = "FETCH_BILLING_INFORMATION";
export const FETCH_INDUSTRY = "FETCH_INDUSTRY";
export const ADD_INDUSTRY_TO_COMPANY = "ADD_INDUSTRY_TO_COMPANY";
export const SEND_APPROVED_QUOTES_EMAIL = "SEND_APPROVED_QUOTES_EMAIL";
export const OCR_PROCESSED_DOCUMENT = "OCR_PROCESSED_DOCUMENT";
export const OCR_DOCUMENT_SAVED = "OCR_DOCUMENT_SAVED";
export const OCR_FETCH_ALL_DOCUMENTS = "OCR_FETCH_ALL_DOCUMENTS";
export const OCR_DOCUMENT_ACCEPT = "OCR_DOCUMENT_ACCEPT";
export const OCR_DOCUMENT_DUPLICATE = "OCR_DOCUMENT_DUPLICATE";
export const OCR_DOCUMENT_DELETE = "OCR_DOCUMENT_DELETE";
export const OCR_DOCUMENT_BY_ID = "OCR_DOCUMENT_BY_ID";
export const PO_SUPPLIER_PROPS_API = "PO_SUPPLIER_PROPS_API";

//chat widget start
export const USER_LOGIN_WIDGET = "USER_LOGIN_WIDGET";
export const CHAT_WIDGET_USER_CREATE = "CHAT_WIDGET_USER_CREATE";
export const ADD_GROUPS_CHAT_WIDGET = "ADD_GROUPS_CHAT_WIDGET";
export const CHAT_WIDGET_CONVERSATION = "CHAT_WIDGET_CONVERSATION";
export const CHAT_WIDGET_CONVERSATION_PUSH_MESSAGE =
  "CHAT_WIDGET_CONVERSATION_PUSH_MESSAGE";
export const ADD_USER_TO_GROUP_CHAT_WIDGET = "ADD_USER_TO_GROUP_CHAT_WIDGET";
//chat widget end
export const FETCH_CLIENTS_BY_COMPANY = "FETCH_CLIENTS_BY_COMPANY";
export const ADD_FORM = "ADD_FORM";
export const UPDATE_FORM = "UPDATE_FORM";
export const ADD_FORM_SECTION = "ADD_FORM_SECTION";
export const FETCH_FORM_LIST = "FETCH_FORM_LIST";
export const FETCH_WORKFLOW_FORM_LIST = "FETCH_WORKFLOW_FORM_LIST";
export const FETCH_FORM_BY_ID = "FETCH_FORM_BY_ID";
export const FETCH_TEMPLATE_FORMS = "FETCH_TEMPLATE_FORMS";
export const DELETE_FORM = "DELETE_FORM";
export const ADD_PERSONAL_TASK = "ADD_PERSONAL_TASK";
export const FETCH_PERSONAL_TASK = "FETCH_PERSONAL_TASK";
export const FETCH_INTERGRATION = "FETCH_INTERGRATION";
export const UPDATE_ISCHECK_PERSONAL_TASK = "UPDATE_ISCHECK_PERSONAL_TASK";
export const AZURE_AUTH_TOKEN = "AZURE_AUTH_TOKEN";
export const FETCH_FORM_BY_PROJECT = "FETCH_FORM_BY_PROJECT";
export const LINK_FORM_BY_PROJECT = "LINK_FORM_BY_PROJECT";
export const UNLINK_FORM_BY_PROJECT = "UNLINK_FORM_BY_PROJECT";
export const LINK_TASK_BY_FORM = "LINK_TASK_BY_FORM";
export const FETCH_USER_MAX_AMOUNT = "FETCH_USER_MAX_AMOUNT";
export const UPDATE_USER_MAX_AMOUNT = "UPDATE_USER_MAX_AMOUNT";
export const APPROVED_ORDER = "APPROVED_ORDER";

export const WORKFLOW_LIST_BY_COMPANY = "WORKFLOW_LIST_BY_COMPANY";
export const WORKFLOW_CONDITION_TRIGGER = "WORKFLOW_CONDITION_TRIGGER";
export const WORKFLOW_CONDITION_RULES = "WORKFLOW_CONDITION_RULES";
export const WORKFLOW_CONDITION_TASK_STATUS = "WORKFLOW_CONDITION_TASK_STATUS";
export const WORKFLOW_CONDITION_TASK_LIST = "WORKFLOW_CONDITION_TASK_LIST";
export const WORKFLOW_ACTIONS = "WORKFLOW_ACTIONS";
export const WORKFLOW_TASK_TYPE = "WORKFLOW_TASK_TYPE";
export const WORKFLOW_QUESTIONS = "WORKFLOW_QUESTIONS";
export const WORKFLOW_INFO = "WORKFLOW_INFO";
export const FETCH_PROJECT_BILLING_TERMS = "FETCH_PROJECT_BILLING_TERMS";
export const ADD_NEW_CLIENT = "ADD_NEW_CLIENT";
export const UPDATE_CLIENT_COMPANY = "UPDATE_CLIENT_COMPANY";
export const UPDATE_CLIENT_DETAILS = "UPDATE_CLIENT_DETAILS";
export const FETCH_CLIENT_BY_ID = "FETCH_CLIENT_BY_ID";
export const EXISTING_COMPANY_ADDRESS = "EXISTING_COMPANY_ADDRESS";
export const DELETE_MULTIPLE_ADDRESS = "DELETE_MULTIPLE_ADDRESS";
export const FETCH_CLIENT_CONTACTS_BY_CLIENT_ID =
  "FETCH_CLIENT_CONTACTS_BY_CLIENT_ID";
export const FETCH_CLIENT_TASKS = "FETCH_CLIENT_TASKS";
export const CLIENT_ACTIVITY_TIMELINE = "CLIENT_ACTIVITY_TIMELINE";
export const GET_CREDIT_TYPE_DROPDOWN = "GET_CREDIT_TYPE_DROPDOWN";
export const GET_INVOICE_TYPE_DROPDOWN = "GET_INVOICE_TYPE_DROPDOWN";
export const GET_DISCOUNT_TYPE_DROPDOWN = "GET_DISCOUNT_TYPE_DROPDOWN";
export const ADD_DISCOUNT = "ADD_DISCOUNT";
export const DELETE_CLIENT_CONTACT = "DELETE_CLIENT_CONTACT";
export const FETCH_ID_TYPE = "FETCH_ID_TYPE";
export const FETCH_EMPLOYEETYPE = "FETCH_EMPLOYEETYPE";
export const FETCH_CONTRACT_TYPE = "FETCH_CONTRACT_TYPE";
export const FETCH_COMPANY_CAR = "FETCH_COMPANY_CAR";
export const FETCH_REASONS = "FETCH_REASONS";
export const FETCH_USER_CERTIFICATION = "FETCH_USER_CERTIFICATION";
export const INSERT_DOC_TO_S3 = "INSERT_DOC_TO_S3";
export const SEND_EMAIL_REGISTRATION = "SEND_EMAIL_REGISTRATION";

export const UPDATE_DELETE_COMPANY_CAR = "UPDATE_DELETE_COMPANY_CAR";
export const UPDATE_DELETE_CONTRACT_TYPE = "UPDATE_DELETE_CONTRACT_TYPE";
export const UPDATE_DELETE_EMPLOYEE_TYPE = "UPDATE_DELETE_EMPLOYEE_TYPE";
export const UPDATE_DELETE_ID_TYPE = "UPDATE_DELETE_ID_TYPE";
export const UPDATE_DELETE_REASONS = "UPDATE_DELETE_REASONS";

export const DELETE_COMPANY_CAR = "DELETE_COMPANY_CAR";
export const DELETE_CONTRACT_TYPE = "DELETE_CONTRACT_TYPE";
export const DELETE_EMPLOYEE_TYPE = "DELETE_EMPLOYEE_TYPE";
export const DELETE_ID_TYPE = "DELETE_ID_TYPE";
export const DELETE_REASONS = "DELETE_REASONS";

export const ADD_FORM_RESPONSE = "ADD_FORM_RESPONSE";
export const QUOTE_GENRATE_PDF = "QUOTE_GENRATE_PDF";
export const FETCH_PROJECT_WORKS = "FETCH_PROJECT_WORKS";
export const DELETE_WORK_LIST = "DELETE_WORK_LIST";
export const ADD_WORK_TASK = "ADD_WORK_TASK";
export const DELETE_WORK_TASK = "DELETE_WORK_TASK";
export const FETCH_WORK_TASK_BY_ID = "FETCH_WORK_TASK_BY_ID";
export const UPDATE_WORK_TASK = "UPDATE_WORK_TASK";
export const PROJECT_HIRING_LIST = "PROJECT_HIRING_LIST";
export const PROJECT_HIRE_CREATE = "PROJECT_HIRE_CREATE";
export const PROJECT_HIRE_UPDATE = "PROJECT_HIRE_UPDATE";
export const PROJECT_HIRE_DELETE = "PROJECT_HIRE_DELETE";
export const UPDATE_PROJECT_HIRING_STATUS = "UPDATE_PROJECT_HIRING_STATUS";
export const UPDATE_PROJECT_HIRING_EXTEND_PERIOD =
  "UPDATE_PROJECT_HIRING_EXTEND_PERIOD";
export const PROJECT_RENT_DELETE = "PROJECT_RENT_DELETE";
export const UPDATE_PROJECT_RENT_STATUS = "UPDATE_PROJECT_RENT_STATUS";
export const UPDATE_PROJECT_RENT_EXTEND_PERIOD =
  "UPDATE_PROJECT_RENT_EXTEND_PERIOD";
export const ADD_PHASE_MATERIALS = "ADD_PHASE_MATERIALS";
export const FETCH_PHASE_MATERIALS_BY_PROJECT =
  "FETCH_PHASE_MATERIALS_BY_PROJECT";
export const FETCH_PHASE_MATERIALS_BY_ID = "FETCH_PHASE_MATERIALS_BY_ID";
export const FETCH_ORDER_PICKING_PRODUCT = "FETCH_ORDER_PICKING_PRODUCT";
export const ADD_RETURN_TO_WAREHOUSE = "ADD_RETURN_TO_WAREHOUSE";

export const FETCH_USER_SCHEDULE = "FETCH_USER_SCHEDULE";
export const UPDATE_USER_LOG_TIMER = "UPDATE_USER_LOG_TIMER";
export const UPDATE_USER_TIME_OFF = "UPDATE_USER_TIME_OFF";
export const DELETE_PHASE = "DELETE_PHASE";
export const DELETE_MATERIALS = "DELETE_MATERIALS";
export const ADD_MATERIAL_LIST = "ADD_MATERIAL_LIST";
export const FETCH_MATERIALS_LIST = "FETCH_MATERIALS_LIST";
export const UPDATE_MATERIALS_QUANTITY = "UPDATE_MATERIALS_QUANTITY";
export const UPDATE_TASK_IMAGE = "UPDATE_TASK_IMAGE";
export const FETCH_USER_TITLE = "FETCH_USER_TITLE";
export const ADD_UPDATE_USER_TITLE = "ADD_UPDATE_USER_TITLE";
export const DELETE_USER_TITLE = "DELETE_USER_TITLE";
export const FETCH_PROJECTS_BY_WEEKS = "FETCH_PROJECTS_BY_WEEKS";
export const FETCH_NEXT_WORKID = "FETCH_NEXT_WORKID";
export const SINGLE_UPLOAD_TO_S3 = "SINGLE_UPLOAD_TO_S3";
export const MULTIPLE_UPLOAD_TO_S3 = "MULTIPLE_UPLOAD_TO_S3";
export const DOWNLOAD_DOCUMENT = "DOWNLOAD_DOCUMENT";
export const STORE_TIMER_SCREEN_SHOTS = "STORE_TIMER_SCREEN_SHOTS";
export const TIME_MANAGEMENT_SESSION_TIMELINE =
  "TIME_MANAGEMENT_SESSION_TIMELINE";
export const DELETE_SCREENSHOTS = "DELETE_SCREENSHOTS";
export const TIME_MANAGEMENT_DAILY_SUMMARY = "TIME_MANAGEMENT_DAILY_SUMMARY";
export const ADD_TRANSLATION_DATA = "ADD_TRANSLATION_DATA";
export const ADD_NEW_PROJECT_BILLING = "ADD_NEW_PROJECT_BILLING";
export const DELETE_NEW_PROJECT_BILLING = "DELETE_NEW_PROJECT_BILLING";
export const DELETE_USER_TIME_OFF = "DELETE_USER_TIME_OFF";
export const FECTH_UNITS_PRODUCTS = "FECTH_UNITS_PRODUCTS";
export const MAKING_TEMPLATE_DEFAULT = "MAKING_TEMPLATE_DEFAULT";
export const FETCH_ISDEFAULT_TEMPLATE = "FETCH_ISDEFAULT_TEMPLATE";
export const FILES_INSERT_DOC_TO_S3 = "FILES_INSERT_DOC_TO_S3";
export const ADD_DOCUMENT_TO_TASK = "ADD_DOCUMENT_TO_TASK";
export const ADD_TASK_FORM = "ADD_TASK_FORM";
export const UPDATE_TASK_FORM = "UPDATE_TASK_FORM";
export const DELETE_TASK_FORM = "DELETE_TASK_FORM";
export const FETCH_TASK_FORM = "FETCH_TASK_FORM";
export const DELETE_BOM_ITEM = "DELETE_BOM_ITEM";
export const DELETE_SUB_SECTION_PARTS = "DELETE_SUB_SECTION_PARTS";
export const DRIVE_ADD_FOLDER = "DRIVE_ADD_FOLDER";
export const FETCH_ZERO_PARENTS_FOLDER = "FETCH_ZERO_PARENTS_FOLDER";
export const FETCH_SPIRE_FOLDER_DOCUMENTS = "FETCH_SPIRE_FOLDER_DOCUMENTS";
export const DELETE_DRIVE_FOLDER_OR_FILE = "DELETE_DRIVE_FOLDER_OR_FILE";
export const ADD_DOC_ROOT = "ADD_DOC_ROOT";
export const DRIVE_UPDATE_FOLDER = "DRIVE_UPDATE_FOLDER";
export const FILE_CHUNK_START = "FILE_CHUNK_START";
export const FILE_PRESIGN = "FILE_PRESIGN";
export const FILE_CHUNK_COMPLETE = "FILE_CHUNK_COMPLETE";
export const FILE_CHUNK_ABORT = "FILE_CHUNK_ABORT";
export const FETCH_FORM_CERTIFICATES = "FETCH_FORM_CERTIFICATES";
export const AJIT_SPIRE_API_JSON = "AJIT_SPIRE_API_JSON";
export const COWORKER_CERTIFICATIONS_ADD_UPDTE_DELETE =
  "COWORKER_CERTIFICATIONS_ADD_UPDTE_DELETE";
export const FETCH_TODO_LIST = "FETCH_TODO_LIST";
export const UPDATE_TASK_PRIORITY = "UPDATE_TASK_PRIORITY";
export const UPDATE_TASK_ASSIGNEE = "UPDATE_TASK_ASSIGNEE";
export const UPDATE_TASK_INDEX = "UPDATE_TASK_INDEX";
export const UPDATE_CHECKLIST_DATA = "UPDATE_CHECKLIST_DATA";
export const DELETE_PROJECT = "DELETE_PROJECT";
export const ADD_TASK_DESCRIPTION = "ADD_TASK_DESCRIPTION";
export const FETCH_BRAND_HEALTH_APPLICATION = "FETCH_BRAND_HEALTH_APPLICATION";
export const SUPPLIER_EMAIL_EXIST_OR_NOT = "SUPPLIER_EMAIL_EXIST_OR_NOT";
export const CLIENT_NAME_EXIST_OR_NOT = "CLIENT_NAME_EXIST_OR_NOT";
export const REMOVE_TASK_ASSIGNEE = "REMOVE_TASK_ASSIGNEE";
export const SET_ASSIGNEE_LOCAL_DATA = "SET_ASSIGNEE_LOCAL_DATA";
export const PRODUCT_CATALOGUE_API = "PRODUCT_CATALOGUE_API";
export const FETCH_AUTO_PRODUCT_PART_ITEM_ID =
  "FETCH_AUTO_PRODUCT_PART_ITEM_ID";
export const DUPLICATE_TEMPLATE = "DUPLICATE_TEMPLATE";
export const FETCH_TODO_LIST_BY_PROJECT = "FETCH_TODO_LIST_BY_PROJECT";
export const ADD_DOCUMENT_TO_ORDER = "ADD_DOCUMENT_TO_ORDER";
export const FETCH_DOCUMENT_BY_ORDERID = "FETCH_DOCUMENT_BY_ORDERID";
export const FETCH_PRODUCT_WITHOUT_SUPPLIER = "FETCH_PRODUCT_WITHOUT_SUPPLIER";
export const ADD_SUPPLIER_TO_PRODUCT = "ADD_SUPPLIER_TO_PRODUCT";
export const SUPPLIER_CODE_EXIST_OR_NOT = "SUPPLIER_CODE_EXIST_OR_NOT";
export const SUPPLIER_BAR_CODE = "SUPPLIER_BAR_CODE";
export const SUPPLIER_BAR_CODE_SCAN = "SUPPLIER_BAR_CODE_SCAN";
export const SEND_PO_EMAIL_TO_SUPPLIER = "SEND_PO_EMAIL_TO_SUPPLIER";
export const PART_DUPLICATE = "PART_DUPLICATE";
export const START_PURCHASE_ORDER_EMAIL_JOB = "START_PURCHASE_ORDER_EMAIL_JOB";
export const DEQUEUE_PURCHASE_ORDER_EMAIL_JOB =
  "DEQUEUE_PURCHASE_ORDER_EMAIL_JOB";
export const SET_PURCHASE_ORDER_EMAIL_JOB = "SET_PURCHASE_ORDER_EMAIL_JOB";
export const RESET_PURCHASE_ORDER_EMAIL_JOB = "RESET_PURCHASE_ORDER_EMAIL_JOB";
export const START_RENT_ORDER_EMAIL_JOB = "START_RENT_ORDER_EMAIL_JOB";
export const DEQUEUE_RENT_ORDER_EMAIL_JOB = "DEQUEUE_RENT_ORDER_EMAIL_JOB";
export const SET_RENT_ORDER_EMAIL_JOB = "SET_RENT_ORDER_EMAIL_JOB";
export const RESET_RENT_ORDER_EMAIL_JOB = "RESET_RENT_ORDER_EMAIL_JOB";
export const UPDATE_PRODUCT_DESCRIPTION = "UPDATE_PRODUCT_DESCRIPTION";
export const ADD_TASK_ACTIVITY = "ADD_TASK_ACTIVITY";
export const UPDATE_TASK_ACTIVITY = "UPDATE_TASK_ACTIVITY";
export const SEARCH_ACTIVITY = "SEARCH_ACTIVITY";
export const FETCH_ACTIVITY = "FETCH_ACTIVITY";
export const DELETE_ACTIVITY = "DELETE_ACTIVITY";
export const TIMER_FOR_ACTIVITY = "TIMER_FOR_ACTIVITY";
export const GET_TIMER_FOR_ACTIVITY = "GET_TIMER_FOR_ACTIVITY";
export const FETCH_PROJECT_EQUIPMENT_ACTIVITY =
  "FETCH_PROJECT_EQUIPMENT_ACTIVITY";
export const SEARCH_AI_FOLDER_FILE = "SEARCH_AI_FOLDER_FILE";
export const UPDATE_USER_FILTER = "UPDATE_USER_FILTER";
export const ADD_PARTS_EQUIPMENTS = "ADD_PARTS_EQUIPMENTS";
export const FETCH_PARTS_EQUIPMENTS = "FETCH_PARTS_EQUIPMENTS";
export const UPDATE_PARTS_EQUIPMENTS = "UPDATE_PARTS_EQUIPMENTS";
export const DELETE_PARTS_EQUIPMENTS = "DELETE_PARTS_EQUIPMENTS";
export const UPDATE_TASK_ESTIMATIONS = "UPDATE_TASK_ESTIMATIONS";
export const BUILD_PO_DATA = "BUILD_PO_DATA";
export const DELETE_RESOURCE_PO = "DELETE_RESOURCE_PO";
export const LOGOUT_SESSION = "LOGOUT_SESSION";
export const FETCH_TASK_HISTORY = "FETCH_TASK_HISTORY";
export const FETCH_TASK_TIMESHEET = "FETCH_TASK_TIMESHEET";
export const ADD_UPDATE_TASK_DEPENDENCIES = "ADD_UPDATE_TASK_DEPENDENCIES";
export const DELETE_DEPENDENCIES = "DELETE_DEPENDENCIES";
export const ADD_TASK_PRODUCTS_PART = "ADD_TASK_PRODUCTS_PART";
export const UPDATE_TASK_PRODUCTS_PART = "UPDATE_TASK_PRODUCTS_PART";
export const FETCH_TASK_PRODUCTS_PART = "FETCH_TASK_PRODUCTS_PART";
export const DELETE_TASK_PRODUCTS_PART = "DELETE_TASK_PRODUCTS_PART";
export const FETCH_TASK_COST_DETAILS = "FETCH_TASK_COST_DETAILS";
export const CREATE_TASK_INVOICE = "CREATE_TASK_INVOICE";
export const UPDATE_SECTION_DEFAULT = "UPDATE_SECTION_DEFAULT";
export const DELETE_COMPOSE_PRODUCT = "DELETE_COMPOSE_PRODUCT";
export const UPDATE_TASK_PRODUCT_PART_QTY = "UPDATE_TASK_PRODUCT_PART_QTY";
